import { render, staticRenderFns } from "./fbaResult.vue?vue&type=template&id=67ac86ce&scoped=true"
import script from "./fbaResult.vue?vue&type=script&lang=js"
export * from "./fbaResult.vue?vue&type=script&lang=js"
import style0 from "./fbaResult.vue?vue&type=style&index=0&id=67ac86ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ac86ce",
  null
  
)

export default component.exports